/** Escape a value for CSV (RFC 4180-ish). */
import { formatIndiaDate, formatIndiaDateTime } from "./dateFormat";

export function escapeCsvValue(value: unknown): string {
  if (value == null) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function formatCsvDate(value: unknown): string {
  if (value == null || value === "") return "";
  const formatted = formatIndiaDate(value as string | Date, "");
  return formatted || String(value);
}

export function formatCsvDateTime(value: unknown): string {
  if (value == null || value === "") return "";
  const formatted = formatIndiaDateTime(value as string | Date, "");
  return formatted || String(value);
}

/** Build a filename like `orders_2026-07-15.csv` or `orders_2026-01-01_to_2026-01-31.csv`. */
export function buildCsvFilename(
  prefix: string,
  fromDate?: string,
  toDate?: string
): string {
  const today = new Date().toISOString().slice(0, 10);
  if (fromDate && toDate) {
    return `${prefix}_${fromDate}_to_${toDate}.csv`;
  }
  if (fromDate) {
    return `${prefix}_from_${fromDate}.csv`;
  }
  if (toDate) {
    return `${prefix}_to_${toDate}.csv`;
  }
  return `${prefix}_${today}.csv`;
}

export function downloadCsv(
  filename: string,
  headers: string[],
  rows: Array<Array<unknown>>
): void {
  const lines = [
    headers.map(escapeCsvValue).join(","),
    ...rows.map((row) => row.map(escapeCsvValue).join(",")),
  ];
  const blob = new Blob(["\uFEFF" + lines.join("\r\n")], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
